module.exports = __webpack_public_path__ + "static/media/customDesignPhoto3.4ec0e95a.png";